import React, { useContext } from "react";

//Components
import VersionTxtComponent from "../../components/VersionTxtComponent/VersionTxtComponent";
import NavbarComponent from "../../components/NavbarComponent/NavbarComponent";
import NavbarMobile from "../../components/NavbarMobile/NavbarMobile";
import NavbarMobileBottom from "../../components/NavbarMobileBotton/NavbarMobileBottom";
import SideMenusComponent from "../../components/SideMenusComponent/SideMenusComponent";
import SurveyBody from "../../components/SurveyBody/SurveyBody";
import LoadingScreenComponent from "../../components/LoadingScreenComponent/LoadingScreenComponent";

//Context
import { LoadingContext } from "../../context/LoadingContext";

const SurveyScreen = ({ userData, userMenuData }) => {
  const { loading } = useContext(LoadingContext);

  return (
    <>
      {loading && <LoadingScreenComponent />}
      <div className="body-container">
        <VersionTxtComponent />
        <div className="body-subcontainer">
          <NavbarComponent userData={userData} />
          <NavbarMobile userData={userData} menuData={userMenuData} />
          <SurveyBody userData={userData} />
          <NavbarMobileBottom />
        </div>
        <SideMenusComponent menuData={userMenuData} />
      </div>
    </>
  );
};

export default SurveyScreen;
